import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
export const VISITOR_UUID_COOKIE_NAME = '__udmy_2_v57r';
export const VISITOR_UUID_HEADER_NAME = 'x-visitoruuid';

/**
 * generateVisitorUuid()
 * Returns a 32 character length uuid with hyphens removed.
 * @returns {string} - 32 character length UUID string without hyphens
 */
export function generateVisitorUuid() {
  return uuidv4().replace(/-/g, '');
}

/**
 * getVisitorUuid()
 * Looks for a visitor uuid cookie (__udmy_2_v57r) and if not set, sets cookie
 * @returns {string} - 32 character length UUID string without hyphens
 */
export function getVisitorUuid() {
  let visitorUuid = Cookies.get(VISITOR_UUID_COOKIE_NAME);

  // For now, generate a visitor UUID when one is missing to support dev
  if (!visitorUuid) {
    visitorUuid = generateVisitorUuid();
    Cookies.set(VISITOR_UUID_COOKIE_NAME, visitorUuid);
  }
  return visitorUuid;
}
//# sourceMappingURL=visitor-uuid.js.map